import config from "lib/config"

export const generateQRUrl = (qrId?: string | null, companyId?: string | null) => {
  if (!qrId || !companyId) return ""
  return `${config.apiEndpoint}/webhooks/qr/${qrId}-${companyId}`
}
